export default __webpack_public_path__ + "static/media/renovation.9c3a46b0.svg";